export default __webpack_public_path__ + "static/media/side left.8f8ba40a.png";